import c_5 from "../../assets/audio-screen/unit5/c_5.mp3"
import c_5_1 from "../../assets/audio-screen/unit5/c_5_1.mp3"


export const audio5 = [
   {
    'text':'Hoa: Xin chào anh, mời anh vào ạ!\nWatanabe: Chào chị, tôi muốn mua 1 cân xoài.\nHoa: Vâng! Xoài ở đằng kia ạ.\nWatanabe: Xoài này bao nhiêu tiền ă cân ạ?\nHoa: 45 ngàn đồng 1 cân anh ạ.\nWatanabe: Cảm ơn chị.\n',
    'audio': c_5,
  },

];

export const audio5_1 = [
    {
     'text':'Sơn: Xin mời vào ạ.\nMs Larry: Chào cô, chúng tôi muốn ăn món bún chả.\nSơn: Vâng, đây ạ. Món này là món đặc trưng ở Hà Nội và rất ngon ạ.\nMs Larry: Một suất bao nhiêu tiền?\nSơn: 35 nghin đồng ạ, ông bà có uống gì không ạ?\nMr Larry: Ah. tôi muốn uống trà đá, bao nhiêu tiền?\nSơn: 5 ngàn đồng 1 cốc ạ, ông bà muốn yống mấy cốc ạ?\nMr Larry: Vậy cho tôi 2 suất bún chả và 2 cốc trà đá.\nSơn: Vâng. Cảm ơn ông bà, làm ơn chờ tôi mộ chút để tôi chuẩn bị ạ.\n',
     'audio': c_5_1,
   },
 
 ];